import { useEffect } from "react";

export default function ProductListScripts() {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const showFilterBtn = document.querySelector('#showFilterBtn');
      const showSortBtn = document.querySelector('#showSortBtn');

      const closeFilterBtn = document.querySelector('#closeFilterBtn');

      const filtersSection = document.querySelector('#FiltersSection');
      const applyFilterBtn = document.querySelector('#applyFilterBtn');
      const ProductSortLayoutLayout = document.querySelector('#ProductSortLayout');
      const ProductSortLayoutBack = document.querySelector('#ProductSortLayoutBack');

      const productSortList = document.querySelector('#ProductSortList');
      const ProductSortLayout = document.querySelector('#ProductSortLayout');
      showFilterBtn?.addEventListener('click', () => {
        filtersSection?.classList.add('!block', '!z-[999999]')
      })

      closeFilterBtn?.addEventListener('click', () => {
        filtersSection?.classList.remove('!block', '!z-[999999]')
      });


      showSortBtn?.addEventListener('click', () => {
        ProductSortLayoutLayout?.classList.add('!opacity-100', '!flex');
        ProductSortLayoutBack?.classList.add('!opacity-100', '!block')
        productSortList?.classList.add('!opacity-100', '!translate-y-0', '!top-0')
      })

      ProductSortLayoutBack?.addEventListener('click', () => {
        ProductSortLayout?.classList.remove('!opacity-100', '!flex');
        ProductSortLayoutBack?.classList.remove('!opacity-100', '!block')
        productSortList?.classList.remove('!opacity-100', '!translate-y-0', '!top-0')
      })

      applyFilterBtn?.addEventListener('click', () => {
        filtersSection?.classList.remove('!block', '!z-[999999]')
      })

      window.onscroll = function () {
        if (window.innerWidth > 992) {
          if ((document.body.offsetHeight + Math.ceil(window.pageYOffset)) + 180 >= window.innerHeight) {
            filtersSection?.classList.remove('992:top-0', '992:bottom-auto');
            filtersSection?.classList.add('992:bottom-0', '992:top-auto')
          } else {
            filtersSection?.classList.add('992:top-0', '992:bottom-auto');
            filtersSection?.classList.remove('992:bottom-0', '992:top-auto')
          }
        }
      }
    }
  }, [])
  return null;
}